 
import React, { useState, useEffect, useMemo } from "react";
import { 
  Card, 
  Row, 
  Col, 
  DatePicker, 
  Space, 
  Table, 
  Tag, 
  Select, 
  Typography,
  Tooltip,
  Button,
  Checkbox
} from "antd";
import { 
  PhoneOutlined, 
  PhoneFilled, 
  CheckCircleOutlined, 
  CloseCircleOutlined, 
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  FilePdfOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import api from "../api/Api";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  Legend,
   BarChart, 
   Bar
} from 'recharts';
import { useNavigate } from "react-router-dom";
import { FaFileCsv } from "react-icons/fa6";
 

 

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Title, Text } = Typography;
const CheckboxGroup = Checkbox.Group;

const ListagemChamadas = () => {
    const navigate = useNavigate();
  const inicioMes = dayjs().startOf("month");
  const fimMes = dayjs().endOf("month");
const perfil = localStorage.getItem("perfil");
  const [datas, setDatas] = useState([inicioMes, fimMes]);
  const [loading, setLoading] = useState(false);
  const [chamadas, setChamadas] = useState([]);
  const [statusFiltro, setStatusFiltro] = useState(null);
  const [dadosChart, setDadosChart] = useState([]);
  const [tiposSelecionados, setTiposSelecionados] = useState(['Completada', 'Sem_Resposta', 'Abandonada']);

  const [totalChamadas, setTotalChamadas] = useState(0);
  const [totalAtendidas, setTotalAtendidas] = useState(0);
  const [totalNaoAtendidas, setTotalNaoAtendidas] = useState(0);
  const [totalAbandonadas, setTotalAbandonadas] = useState(0);
  const [dadosAgente, setDadosAgente] = useState([]);
  const [filaFiltro, setFilaFiltro] = useState("");
const [filasDisponiveis, setFilasDisponiveis] = useState([]);
const [operadorFiltro, setOperadorFiltro] = useState("");
const [operadoresDisponiveis, setOperadoresDisponiveis] = useState([]);




useEffect(() => {
  if (datas && datas[0] && datas[1]) {
    fetchChamadas();
    fetchDashboard();
    fetchDadosChart();
    fetchDadosPorAgente();
  }
}, [datas, filaFiltro]);


 


 

const irParaGerarPDF = () => {
  // Prepara todos os parâmetros de filtro
  const params = new URLSearchParams({
    dataInicio: datas[0].format("YYYY-MM-DD"),
    dataFim: datas[1].format("YYYY-MM-DD"),
    
  });

  // Abre em nova aba
  const url = `/chamadas_pdf?${params.toString()}`;
  window.open(url, '_blank');
};



const irParaGerarExcel = () => {
  const params = new URLSearchParams({
    dataInicio: datas[0].format("YYYY-MM-DD"),
    dataFim: datas[1].format("YYYY-MM-DD"),
    statusFiltro: statusFiltro || '',
    filasSelecionadas: filaFiltro || '',
    operadorFiltro: operadorFiltro || '',  
  });

  window.open(`/chamadas-excel?${params.toString()}`, "_blank");
};

  // Buscar dados para o chart
  const fetchDadosChart = async () => {
    try {
       const payload = {
      dataInicio: datas[0].format("YYYY-MM-DD"),
      dataFim: datas[1].format("YYYY-MM-DD"),
      fila: filaFiltro || null, // 👈 adicionado
    };
      const response = await api.ListChamadaPorDia(payload);
      if (Array.isArray(response)) {
        // Formatar os dados para o chart
        const dadosFormatados = response.map(item => ({
          ...item,
        dia: (/^\d{2}:\d{2}$/.test(item.dia)) 
        ? item.dia                                     // já é uma hora "08:00"
        : dayjs(item.dia, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('DD/MM'),
          Completada: parseInt(item.Completada) || 0,
          Sem_Resposta: parseInt(item.Sem_Resposta) || 0,
          Abandonada: parseInt(item.Abandonada) || 0
        }));
        setDadosChart(dadosFormatados);
      }
    } catch (error) {
      console.error("Erro ao buscar dados do chart:", error);
    }
  };

  const fetchDadosPorAgente = async () => {
  try {
    const payload = {
      dataInicio: datas[0].format("YYYY-MM-DD"),
      dataFim: datas[1].format("YYYY-MM-DD"),
      fila: filaFiltro || null, 
    };
    const response = await api.ListChamadaPorAgente(payload);
    if (Array.isArray(response)) {
      const dadosFormatados = response.map(item => ({
        agente: item.agente,
        total_atendidas: Number(item.total_atendidas) || 0
      }));
      setDadosAgente(dadosFormatados);
    }
  } catch (error) {
    console.error("Erro ao buscar dados por agente:", error);
  }
};

  const fetchChamadas = async () => {
    try {
      setLoading(true);
const payload = {
      dataInicio: datas[0].format("YYYY-MM-DD"),
      dataFim: datas[1].format("YYYY-MM-DD"),
    
    };
      const response = await api.ListChamadaMovicel(payload);
      if (Array.isArray(response)) {
        const formatado = response.map((item) => ({
          ...item,
          status: item.status
        }));
        setChamadas(formatado);
         
       const filasUnicas = [...new Set(response.map((c) => c.fila).filter(Boolean))];
setFilasDisponiveis(filasUnicas);

const operadoresUnicos = [...new Set(response.map((c) => c.agente).filter(Boolean))];
setOperadoresDisponiveis(operadoresUnicos);

  
      }
      
    } catch (error) {
      console.error("Erro ao buscar chamadas:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDashboard = async () => {
    try {
      const payload = {
      dataInicio: datas[0].format("YYYY-MM-DD"),
      dataFim: datas[1].format("YYYY-MM-DD"),
      fila: filaFiltro || null, // 👈 adicionado
    };
      const response = await api.ListDashboard(payload);
      if (response && typeof response === "object") {
        setTotalChamadas(response.todas);
        setTotalAtendidas(response.atendidas);
        setTotalNaoAtendidas(response.n_atendidas);
        setTotalAbandonadas(response.abandonadas);
      }
    } catch (error) {
      console.error("Erro ao buscar dados do dashboard:", error);
    }
  };

  // Configurações das áreas do chart
  const areasConfig = {
    Completada: {
      color: "#52c41a",
      gradientId: "colorCompletada",
      stroke: "#52c41a",
      name: "Completada"
    },
    Sem_Resposta: {
      color: "#ff4d4f",
      gradientId: "colorSemResposta",
      stroke: "#ff4d4f",
      name: "Sem resposta"
    },
    Abandonada: {
      color: "#fa8c16",
      gradientId: "colorAbandonada",
      stroke: "#fa8c16",
      name: "Abandonada"
    }
  };

  

const filteredChamadas = chamadas.filter((c) => {
  const filtroStatusOk = !statusFiltro || c.status?.toLowerCase() === statusFiltro.toLowerCase();
  const filtroFilaOk = !filaFiltro || c.fila === filaFiltro;
 const filtroOperadorOk = !operadorFiltro || c.agente === operadorFiltro;
  return filtroStatusOk && filtroFilaOk && filtroOperadorOk;
});








  const stats = useMemo(() => [
    { 
      title: "Total de chamadas", 
      value: totalChamadas, 
      color: "#1890ff",
      icon: <PhoneFilled />,
      description: "Chamadas totais recebidas"
    },
    { 
      title: "Atendidas", 
      value: totalAtendidas, 
      color: "#52c41a",
      icon: <CheckCircleOutlined />,
      description: "Chamadas completadas com sucesso"
    },
    { 
      title: "Não atendidas", 
      value: totalNaoAtendidas, 
      color: "#ff4d4f",
      icon: <CloseCircleOutlined />,
      description: "Chamadas sem resposta"
    },
    { 
      title: "Abandonadas", 
      value: totalAbandonadas, 
      color: "#fa8c16",
      icon: <ExclamationCircleOutlined />,
      description: "Chamadas abandonadas antes do atendimento"
    },
  ], [totalChamadas, totalAtendidas, totalNaoAtendidas, totalAbandonadas]);

  const columns = [
    {
      title: "Data e hora",
      dataIndex: "data",
      key: "data",
      width: 160,
      render: (text) => (
        <div>
          <div style={{ fontWeight: 500 }}>{dayjs(text).format("DD/MM/YYYY")}</div>
          <Text type="secondary" style={{ fontSize: "12px" }}>
            {dayjs(text).format("HH:mm")}
          </Text>
        </div>
      ),
    },
    
 
     {
      title: "Fila",
      dataIndex: "fila",
      key: "fila",
      width: 120,
    },
    {
      title: "Tempo de espera",
      dataIndex: "espera",
      key: "espera",
      width: 80,
      align: "center",
      render: (duracao) => <Text>{duracao}</Text>,
    },
    {
      title: "Duração",
      dataIndex: "duracao",
      key: "duracao",
      width: 80,
      align: "center",
      render: (duracao) => <Text>{duracao}</Text>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 140,
      render: (status) => {
        const statusConfig = {
          "Completada": { color: "#52c41a", icon: <CheckCircleOutlined /> },
          "Sem resposta": { color: "#ff4d4f", icon: <CloseCircleOutlined /> },
          "Abandonada": { color: "#fa8c16", icon: <ExclamationCircleOutlined /> },
        };
        
        const config = statusConfig[status] || { color: "#d9d9d9", icon: <InfoCircleOutlined /> };
        
        return (
          <Tag 
            color={config.color} 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '4px',
              padding: '4px 8px',
              borderRadius: '6px',
              border: 'none',
              margin: 0
            }}
          >
            {config.icon}
            {status}
          </Tag>
        );
      },
    },
      {
      title: "Operador",
      dataIndex: "agente",
      key: "agente",
      width: 120,
    },
  ];

  // Opções para os checkboxes
  const opcoesCheckbox = [
    { label: 'Completada', value: 'Completada' },
    { label: 'Sem resposta', value: 'Sem_Resposta' },
    { label: 'Abandonada', value: 'Abandonada' },
  ];

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "linear-gradient(135deg, #f5f7fa 0%, #e4efe9 100%)",
      }}
    >
      {/* Container principal com scroll */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "24px",
        }}
      >
        {/* Cabeçalho */}
        <div style={{ marginBottom: "24px" }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'flex-start',
            flexWrap: 'wrap',
            gap: '16px'
          }}>
            <div>
              <Title level={2} style={{ margin: 0, color: "#1a3353", fontWeight: 700 }}>
                Gestão de chamadas
              </Title>
               
            </div>
            
            <Space size="middle" wrap>
              <div>
                <Text strong style={{ display: 'block', marginBottom: '6px', fontSize: '13px' }}>
                  Período
                </Text>
                <RangePicker
                  format="DD/MM/YYYY"
                  value={datas}
                  onChange={(values) => setDatas(values)}
                  style={{ 
                    borderRadius: "8px",
                    minWidth: '240px'
                  }}
                  size="middle"
                />
              </div>
              
              <div>
                <Text strong style={{ display: 'block', marginBottom: '6px', fontSize: '13px' }}>
                  Status
                </Text>
                <Select
                  placeholder="Filtrar por status"
                  allowClear
                  onChange={(value) => setStatusFiltro(value)}
                  style={{ width: 180 }}
                  size="middle"
                >
                  <Option value="Completada">Completada</Option>
                  <Option value="Sem Resposta">Sem resposta</Option>
                  <Option value="Abandonada">Abandonada</Option>
                </Select>
                
                <Select
  placeholder="Filtrar por Fila"
  value={filaFiltro}
  onChange={(value) => setFilaFiltro(value)}
  allowClear
  style={{ width: 200, marginLeft: 8 }}
>
  {filasDisponiveis.map((fila) => (
    <Option key={fila} value={fila}>
      {fila}
    </Option>
  ))}
</Select>

 

{perfil === "ADMIN" && (
  <Select
    placeholder="Filtrar por Operador"
    value={operadorFiltro}
    onChange={(value) => setOperadorFiltro(value)}
    allowClear
    style={{ width: 200, marginLeft: 8 }}
  >
    {operadoresDisponiveis.map((operador) => (
      <Option key={operador} value={operador}>
        {operador}
      </Option>
    ))}
  </Select>
)}




              </div>
            </Space>
          </div>
        </div>

        {/* Cards de Métricas */}
        <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
          {stats.map((item, index) => (
            <Col xs={24} sm={12} lg={6} key={index}>
              <Tooltip title={item.description} placement="top">
                <Card
                  bordered={false}
                  style={{
                    borderRadius: "12px",
                    background: `linear-gradient(135deg, ${item.color}15 0%, ${item.color}08 100%)`,
                    border: `1px solid ${item.color}20`,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                    height: '100%',
                    transition: 'all 0.3s ease',
                  }}
                  bodyStyle={{ padding: '20px' }}
                  hoverable
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div
                      style={{
                        backgroundColor: item.color,
                        color: "white",
                        borderRadius: "12px",
                        width: 54,
                        height: 54,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "20px",
                        flexShrink: 0,
                      }}
                    >
                      {item.icon}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <Text style={{ 
                        fontSize: "14px", 
                        color: '#666', 
                        fontWeight: 500,
                        display: 'block',
                        marginBottom: '4px'
                      }}>
                        {item.title}
                      </Text>
                      <div style={{ 
                        fontSize: "28px", 
                        fontWeight: "bold", 
                        color: item.color, 
                        lineHeight: 1.2 
                      }}>
                        {item.value}
                      </div>
                    </div>
                  </div>
                </Card>
              </Tooltip>
            </Col>
          ))}
        </Row>

        {/* Novo Chart de Ondas */}
        <Card
          style={{
            marginTop: "16px",
            borderRadius: "12px",
            boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
            marginBottom: "24px",
          }}
          title={
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
              <span style={{ fontWeight: 'bold', fontSize: '16px' }}>Chamadas por Dia</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Text strong style={{ fontSize: '14px', marginRight: '8px' }}>Mostrar:</Text>
                <CheckboxGroup 
                  options={opcoesCheckbox}
                  value={tiposSelecionados}
                  onChange={setTiposSelecionados}
                />
              </div>
            </div>
          }
          bordered={false}
        >
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={dadosChart} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
              <defs>
                {Object.entries(areasConfig).map(([key, config]) => (
                  <linearGradient key={config.gradientId} id={config.gradientId} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor={config.color} stopOpacity={0.8} />
                    <stop offset="80%" stopColor={config.color} stopOpacity={0.1} />
                  </linearGradient>
                ))}
              </defs>

             
              <XAxis 
                dataKey="dia" 
                tick={{ fontSize: 12 }} 
              />
              <YAxis />
             <RechartsTooltip
  content={({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const completadas = payload.find(p => p.dataKey === "Completada")?.value || 0;
      const semResposta = payload.find(p => p.dataKey === "Sem_Resposta")?.value || 0;
      const abandonadas = payload.find(p => p.dataKey === "Abandonada")?.value || 0;
      const total = payload[0]?.payload?.total || 0;

      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
          }}
        >
          <p style={{ margin: 0, fontWeight: "bold" }}>{label}</p>
          <p style={{ color: "#52c41a", margin: 0 }}>Completada: {completadas}</p>
          <p style={{ color: "#ff4d4f", margin: 0 }}>Sem Resposta: {semResposta}</p>
          <p style={{ color: "#fa8c16", margin: 0 }}>Abandonada: {abandonadas}</p>
          <hr style={{ margin: "6px 0" }} />
          <p style={{ margin: 0, fontWeight: "bold", color: "#000" }}>
            Total: {total}
          </p>
        </div>
      );
    }
    return null;
  }}
/>

              <Legend />

              {/* Renderizar apenas as áreas selecionadas */}
              {tiposSelecionados.includes('Completada') && (
                <Area
                  type="linear"
                  dataKey="Completada"
                  stroke={areasConfig.Completada.stroke}
                  strokeWidth={2}
                  fill={`url(#${areasConfig.Completada.gradientId})`}
                  dot={{ r: 4, stroke: areasConfig.Completada.stroke, strokeWidth: 1, fill: "#fff" }}
                  activeDot={{ r: 6, stroke: areasConfig.Completada.stroke, strokeWidth: 2, fill: areasConfig.Completada.stroke }}
                  name="Completada"
                />
              )}
              
              {tiposSelecionados.includes('Sem_Resposta') && (
                <Area
                  type="linear"
                  dataKey="Sem_Resposta"
                  stroke={areasConfig.Sem_Resposta.stroke}
                  strokeWidth={2}
                  fill={`url(#${areasConfig.Sem_Resposta.gradientId})`}
                  dot={{ r: 4, stroke: areasConfig.Sem_Resposta.stroke, strokeWidth: 1, fill: "#fff" }}
                  activeDot={{ r: 6, stroke: areasConfig.Sem_Resposta.stroke, strokeWidth: 2, fill: areasConfig.Sem_Resposta.stroke }}
                  name="Sem resposta"
                />
              )}
              
              {tiposSelecionados.includes('Abandonada') && (
                <Area
                  type="linear"
                  dataKey="Abandonada"
                  stroke={areasConfig.Abandonada.stroke}
                  strokeWidth={2}
                  fill={`url(#${areasConfig.Abandonada.gradientId})`}
                  dot={{ r: 4, stroke: areasConfig.Abandonada.stroke, strokeWidth: 1, fill: "#fff" }}
                  activeDot={{ r: 6, stroke: areasConfig.Abandonada.stroke, strokeWidth: 2, fill: areasConfig.Abandonada.stroke }}
                  name="Abandonada"
                />
              )}
            </AreaChart>
          </ResponsiveContainer>
        </Card>



        {/* Chamadas Por Usuário */}

{perfil === "ADMIN" && (

<Card
  style={{
    marginTop: "16px",
    borderRadius: "12px",
    boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
    marginBottom: "24px",
  }}
  title={
    <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
      Chamadas atendidas por operador
    </span>
  }
  bordered={false}
>
  <ResponsiveContainer width="100%" height={300}>
    <BarChart
      data={dadosAgente}
      margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
    >
      
      <XAxis 
        dataKey="agente" 
        tick={{ fontSize: 12 }} 
      />
      <YAxis />
      <RechartsTooltip 
        contentStyle={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          border: "1px solid #d9d9d9",
        }}
      />
      <Legend />
      <Bar 
        dataKey="total_atendidas" 
        fill="#1890ff" 
        name="Chamadas atendidas" 
        barSize={40}
        radius={[8, 8, 0, 0]} 
      />
    </BarChart>
  </ResponsiveContainer>
</Card>
)}





 

        {/* Tabela de Chamadas */}
   <Card
  bordered={false}
  style={{
    borderRadius: "12px",
    background: "white",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    marginBottom: "24px",
    height: "calc(100vh - 350px)", // ajusta conforme o espaço dos outros elementos
    display: "flex",
    flexDirection: "column",
  }}
>
 <div style={{ padding: '20px 20px 0 20px' }}>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              marginBottom: '16px'
            }}>
              <div>
                <Title level={4} style={{ margin: 0 }}>Registo de chamadas</Title>
                
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Tag color="blue" style={{ fontSize: '14px', padding: '4px 12px', borderRadius: '6px' }}>
                  {filteredChamadas.length} chamadas
                </Tag>
                 <Button 
                  type="text" 
                  icon={<FaFileCsv  />}
                  onClick={irParaGerarExcel}
                  style={{ color: '#198754' }}
                  size="small"
                >
                  Excel
                </Button>
                <Button 
                  type="text" 
                  icon={<FilePdfOutlined />}
                  onClick={irParaGerarPDF}
                  style={{ color: '#dc3545' }}
                  size="small"
                >
                  PDF
                </Button>
              </div>
            </div>
          </div>

  <div style={{ flex: 1, overflowY: "auto", padding: "0 20px 20px 20px" }}>
    <Table
      rowKey="id"
      columns={columns}
      dataSource={filteredChamadas}
      loading={loading}
      pagination={{
        pageSize: 5,
        showSizeChanger: true,
        showQuickJumper: true,
        position: ['bottomCenter'],
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} de ${total} chamadas`,
      }}
      scroll={{ x: 800 }}
    />
  </div>
</Card>

      </div>
    </div>
  );
};

export default ListagemChamadas;